module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"alwaysShown":"Always shown","neverShown":"Never shown"},"de":{"alwaysShown":"Immer anzeigen","neverShown":"Nie anzeigen"},"fr":{"alwaysShown":"Toujours montrer","neverShown":"Ne jamais montrer"},"it":{"alwaysShown":"Mostra sempre","neverShown":"Non mostrare mai"}}')
  delete Component.options._Ctor
}
